import { BehaviorSubject }	from 'rxjs';
import { Component }        from '@angular/core';
import {
	ConfigService,
	StateService,
	UtilityService
}														from '../../';

export interface AboutConfigProtocol {
  brandLogo:  string;
  version:    string;
}

@Component({
  selector:			'electra-about',
  styleUrls:		['./about.component.scss'],
  templateUrl:	'./about.component.html'
})
export class AboutComponent {
  config: AboutConfigProtocol;

  logoImage = './assets/electraAssets/interaptLogo.png';
  linkText  = 'interapt.com';
  linkUrl   = 'http://www.interapt.com';

  constructor(private configService: ConfigService, private stateService: StateService, private utilityService: UtilityService) {
    configService.about.subscribe(data => { this.gotConfig(data); });

    console.log('About component created');
  }

	closeClick() {
		this.stateService.state = 'more';
	}

  gotConfig(config: AboutConfigProtocol) {
    this.config = config;
  }

  linkClick() {
    this.utilityService.openUrl(this.linkUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/about/about.component.ts